// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1UtrU","name":"Header_name__3RF_6","birthday":"Header_birthday__3oWMH","skeleton":"Header_skeleton__SFcek"};